import { AxiosError } from 'axios';
import { baseService } from 'services';
import { IErrorResponse, ISuccessResponse } from 'interface/apiInterface';
import {
  ISecret,
  ICreateSecret,
  IUpdateSecret,
  IDeleteSecret,
  ISearchSecrets,
} from 'interface/secretsInterface';
import {
  commonError,
  createSecretEP,
  updateSecretEP,
  deleteSecretEP,
  searchSecretsEP,
} from 'services/constants';

class SecretMockService {
  commonResponse = async <T = null>(
    data: T | null = null,
  ): Promise<ISuccessResponse<T> | IErrorResponse<AxiosError>> => {
    try {
      return await new Promise<ISuccessResponse>(resolve => {
        setTimeout(() => {
          resolve({
            data: data ?? null,
            status: 200,
            message: 'success',
          });
        }, 1000);
      });
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };

  createSecret = async () => {
    return this.commonResponse();
  };

  updateSecret = async () => {
    return this.commonResponse();
  };

  deleteSecret = async () => {
    return this.commonResponse();
  };

  searchSecrets = async () => {
    return this.commonResponse();
  };
}

class SecretService {
  createSecret = async (
    data: ICreateSecret,
  ): Promise<ISuccessResponse<ISecret> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(createSecretEP, data);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };

  updateSecret = async (
    data: IUpdateSecret,
  ): Promise<ISuccessResponse<ISecret> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(updateSecretEP, data);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };

  deleteSecret = async (
    data: IDeleteSecret,
  ): Promise<ISuccessResponse<null> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(deleteSecretEP, data);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };

  searchSecrets = async (
    searchParams: ISearchSecrets,
  ): Promise<ISuccessResponse<ISecret[]> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(searchSecretsEP, searchParams);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
}

const secretService: SecretService | SecretMockService =
  process.env.REACT_APP_MOCK_API === 'true'
    ? new SecretMockService()
    : new SecretService();

export default secretService;
